import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import './Profile.css';
import axios from 'axios';

const MultipleDistricts = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    useEffect(() => {
        const data = sessionStorage.getItem('userData');
        if (data) {
            setUserData(JSON.parse(data));
        }
    }, []);
    const adminEmail = sessionStorage.getItem('adminEmail');
    const authToken = sessionStorage.getItem('authToken');
    const userId = sessionStorage.getItem('userId');
    const handleLogout = () => {
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('authToken');
        sessionStorage.removeItem('adminEmail');
        sessionStorage.removeItem('userDistrict');
        navigate('/');
    };



    // -------------------------------------------district ---------------------------------------



    const [districts, setDistricts] = useState([]);
    const [newDistrict, setNewDistrict] = useState('');
    const [editId, setEditId] = useState(null);
    const [showForm, setShowForm] = useState(false);

    const BASE_URL = 'https://lionsnewsapi.emedha.in/superAdmin';

    // Fetch districts from backend
    const fetchDistricts = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/districtsget`);
            setDistricts(res.data);
        } catch (err) {
            console.error('Failed to fetch districts:', err);
        }
    };

    useEffect(() => {
        fetchDistricts();
    }, []);

    const handleAddDistrict = async () => {
        if (!newDistrict.trim()) return;

        try {
            if (editId !== null) {
                // Update
                await axios.put(`${BASE_URL}/districtsput/${editId}`, { name: newDistrict });
            } else {
                // Create
                await axios.post(`${BASE_URL}/districtspost`, { name: newDistrict });
            }

            setNewDistrict('');
            setEditId(null);
            setShowForm(false);
            fetchDistricts(); // Refresh list
        } catch (err) {
            console.error('Error saving district:', err);
        }
    };

    const handleEdit = (district) => {
        setNewDistrict(district.name);
        setEditId(district.id);
        setShowForm(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${BASE_URL}/districtsdeletw/${id}`);
            fetchDistricts(); // Refresh list
        } catch (err) {
            console.error('Error deleting district:', err);
        }
    };





    return (
        <>
            <div className="sidebar-nav">
                <h2>Menu</h2>
                <ul>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboard'}>Posts</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboardGreetings'}>Greetings</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminAdminUsers'}>Admin's</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminUsers'}>Users's</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdminDashboardProfile'}>Profile</button></li>
                    <li><button className="side-button" onClick={() => window.location.href = '/superAdmin-multiple-districts'}>Multipule Districts</button></li>
                    <li><button className="side-button" onClick={handleLogout}>LogOut</button></li>
                </ul>
            </div>

            <div className="profile-content">
                <h1>MultipleDistricts</h1>
                <div className="col-md-9 p-4">
                    <button className="btn btn-success mb-3" onClick={() => setShowForm(!showForm)}>{showForm ? 'Close' : 'Add District'}</button>

                    {showForm && (
                        <div className="mb-4">
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Enter district name" value={newDistrict} onChange={(e) => setNewDistrict(e.target.value)} />
                                <button className="btn btn-primary" onClick={handleAddDistrict}>{editId !== null ? 'Update' : 'Add'}</button>
                            </div>
                        </div>
                    )}


                    <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>District Name</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {districts.length === 0 ? (
                                    <tr>
                                        <td colSpan="3" className="text-center">No districts added yet.</td>
                                    </tr>
                                ) : (
                                    districts.map((district, index) => (
                                        <tr key={district.id}>
                                            <td>{index + 1}</td>
                                            <td>{district.name}</td>
                                            <td>
                                                <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(district)}>Edit</button>
                                                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(district.id)}>Delete</button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MultipleDistricts;
